import { EDatePickerMode } from '../../../types'
import { IDatePickerModeLang } from '../../../types/lang'

export const datePickerModeLang: IDatePickerModeLang = {
	date_picker_mode: {
		[EDatePickerMode.today]: 'today',
		[EDatePickerMode.yesterday]: 'yesterday',
		[EDatePickerMode.currentWeek]: 'current week',
		[EDatePickerMode.last7Days]: 'last 7 days',
		[EDatePickerMode.currentMonth]: 'current month',
		[EDatePickerMode.lastMonth]: 'last month',
		[EDatePickerMode.last30Days]: 'last 30 days',
		[EDatePickerMode.currentYear]: 'current year',
		[EDatePickerMode.pastYear]: 'past year'
	}
}